import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      text: "I can't thank Carter Case enough for creating 'Ned and Nancy.' These books have become an essential part of my classroom. The kids absolutely adore the characters and the witty storytelling. It's a fantastic way to introduce humor and mystery in children's literature while promoting critical thinking.",
      author: "JENNIFER L.",
      role: "School Teacher"
    },
    {
      text: "Ned and Nancy are my absolute favorites! I can't get enough of their hilarious adventures. It's like they take me on a journey full of surprises every time I open one of their books. Carter Case, you're the coolest!",
      author: "ALICIA H.",
      role: "Parent"
    },
    {
      text: "Our book club chose 'Ned and Nancy' for our children's selection, and it was a hit! Not only did the kids love it, but the parents found themselves chuckling along as well. Carter Case's storytelling is truly magical; it's a must-read for kids and adults alike.",
      author: "JUAN C.",
      role: "Book Club Member"
    }
  ];

  return (
    <div className="py-24 relative overflow-hidden bg-white">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              background: 'linear-gradient(45deg, #4169E1, #60A5FA)',
              width: `${10 + Math.random() * 20}px`,
              height: `${10 + Math.random() * 20}px`,
              opacity: 0.1,
            }}
            animate={{
              y: [0, -20, 0],
              opacity: [0.1, 0.2, 0.1],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center mb-16"
          style={{ color: '#4169E1' }}
        >
          What Readers Are Saying About Ned and Nancy
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              whileHover={{ scale: 1.02 }}
              className="relative"
            >
              {/* Quote Mark */}
              <div className="absolute -top-4 -left-2 text-8xl text-blue-500 opacity-20 leading-none">"</div>
              
              {/* Card */}
              <div className="bg-white rounded-xl p-8 shadow-lg relative">
                {/* Gradient Border */}
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500 to-blue-300 opacity-20" />
                
                {/* Content */}
                <div className="relative">
                  <p className="text-slate-700 text-lg mb-6 relative z-10">
                    {testimonial.text}
                  </p>
                  <div className="border-t border-slate-200 pt-4">
                    <p className="font-bold text-blue-600">{testimonial.author}</p>
                    <p className="text-slate-600">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;